module.exports = __webpack_public_path__ + "static/img/help_09study_02.625c060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_09study_02.png
// module id = 706
// module chunks = 140